import React, { useEffect, useState } from "react";
import { updateBlogPostsShareCount } from "../../redux/actions/postAction";
import { modalState } from "../../redux/actions/modalAction";
import { connect } from "react-redux";
import Share from "./Share";
import ShareIcon from "../../assets/card_icons/ShareIcon";
import BookmarkIcon from "../../assets/card_icons/BookmarkIcon";
import BookmarkFilledIcon from "../../assets/card_icons/BookmarkFIlledIcon";
import CommentIcon from "../../assets/card_icons/CommentIcon";
import HeartIcon from "../../assets/card_icons/HeartIcon";
import HeartFilledIcon from "../../assets/card_icons/HeartFilledIcon";
import IconButton from "@material-ui/core/IconButton";
import { Divider, message } from "antd";
import { useAuthStore } from "../../store/AuthStore";
import { useMutation } from "@tanstack/react-query";
import {
  bookmarkPostAPI,
  likePostAPI,
  unBookmarkPostAPI,
  unlikePostAPI,
} from "../../api/BookmarkPost";
import { queryClient } from "../../index";

const FloatIcons = ({
  updateBlogPostsShareCount,
  modalState,
  post,
  handleGoToComment,
}) => {
  const { isLoggedIn } = useAuthStore();

  const [showShare, setShowShare] = useState(false);

  const { mutate: bookmark } = useMutation({
    mutationFn: (postId) => bookmarkPostAPI(postId),
    onSuccess: () => {
      message.success("Bookmarked Successfully");
      queryClient.invalidateQueries({ queryKey: ["GetPostBySlug"] });
    },
  });

  const { mutate: unBookmark } = useMutation({
    mutationFn: (postId) => unBookmarkPostAPI(postId),
    onSuccess: () => {
      message.success("Removed Bookmark Successfully");
      queryClient.invalidateQueries({ queryKey: ["GetPostBySlug"] });
    },
  });

  const { mutate: like } = useMutation({
    mutationFn: (postId) => likePostAPI(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetPostBySlug"] });
    },
  });

  const { mutate: unlike } = useMutation({
    mutationFn: (postId) => unlikePostAPI(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetPostBySlug"] });
    },
  });

  const toggeShare = () => {
    updateBlogPostsShareCount(post?.id);
    setShowShare(!showShare);
  };

  const getMedia = () => {
    if (post?.imageUrl) {
      return post?.imageUrl;
    } else if (post?.sections?.length && post?.sections[0].value) {
      return post?.sections[0].value;
    } else {
      return window.location.href;
    }
  };

  const handleLike = async () => {
    if (!isLoggedIn) {
      modalState(true);
      return;
    }

    if (post.isLiked) {
      unlike(post.id);
    } else {
      like(post.id);
    }
  };

  const handleBookmark = () => {
    if (!isLoggedIn) {
      modalState(true);
      return;
    }

    if (post.isBookmarked) {
      unBookmark(post.id);
    } else {
      bookmark(post.id);
    }
  };

  const toggleShareModal = () => {
    updateBlogPostsShareCount(post?.id);
    setShowShare(!showShare);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    toggleShareModal();
  };

  return (
    <div className="icons">
      <div>
        <IconButton onClick={handleLike}>
          {post.isLiked ? <HeartFilledIcon /> : <HeartIcon />}
        </IconButton>
        <p>{post.likeCount}</p>
      </div>
      <div className="comment">
        <IconButton onClick={() => handleGoToComment()}>
          <CommentIcon />
        </IconButton>
        <p>{post.commentCount}</p>
      </div>
      <Divider type="vertical" style={{ backgroundColor: "#94A3B8" }} />
      <IconButton onClick={handleBookmark}>
        {post.isBookmarked ? <BookmarkFilledIcon /> : <BookmarkIcon />}
      </IconButton>
      <IconButton onClick={handleShare}>
        <ShareIcon />
      </IconButton>

      <Share show={showShare} hide={toggeShare} media={getMedia()} />
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  updateBlogPostsShareCount,
  modalState,
})(FloatIcons);
